import { useState } from 'react';
import { AlertCircle, Loader } from 'lucide-react';
import { login, saveToken } from '../api/api';
import './Login.css';

function Login({ onSuccess }) {
  const [email,   setEmail]   = useState('');
  const [token,   setToken]   = useState('');
  const [error,   setError]   = useState('');
  const [loading, setLoading] = useState(false);

  async function handleSubmit(e) {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const result = await login(email, token);

      if (!result.success) {
        setError(result.message || 'Identifiants incorrects.');
        return;
      }

      saveToken(result.token);
      onSuccess(result.user);
    } catch (err) {
      const msg = err.response?.data?.message || 'Erreur de connexion. Vérifiez votre réseau.';
      setError(msg);
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="login-page">
      <div className="login-card">

        <div className="login-logo">
          <span className="login-logo-text">Monitoring Diese</span>
        </div>

        <h1 className="login-title">Connexion</h1>
        <p className="login-subtitle">Accédez au tableau de bord de monitoring.</p>

        <form className="login-form" onSubmit={handleSubmit}>

          {error && (
            <div className="login-error">
              <AlertCircle size={15} />
              {error}
            </div>
          )}

          <div className="login-field">
            <label className="login-label" htmlFor="email">Adresse email</label>
            <input
              id="email"
              className="login-input"
              type="email"
              placeholder="vous@example.com"
              value={email}
              onChange={e => setEmail(e.target.value)}
              required
              autoComplete="email"
              autoFocus
            />
          </div>

          <div className="login-field">
            <label className="login-label" htmlFor="token">Token d'accès</label>
            <input
              id="token"
              className="login-input"
              type="password"
              placeholder="Votre token d'accès"
              value={token}
              onChange={e => setToken(e.target.value)}
              required
              autoComplete="off"
            />
          </div>

          <button
            type="submit"
            className="login-submit"
            disabled={loading || !email || !token}
          >
            {loading
              ? <span style={{ display: 'flex', alignItems: 'center', gap: 8, justifyContent: 'center' }}>
                  <Loader size={15} className="spin" /> Connexion…
                </span>
              : 'Se connecter'
            }
          </button>

        </form>
      </div>
    </div>
  );
}

export default Login;
